<script setup lang="ts">
const props = withDefaults(defineProps<{ filled?: boolean; size?: string; color?: string }>(), {
  filled: false,
  size: undefined,
  color: undefined,
});
</script>

<template>
  <svg
    class="nx-icon"
    width="1em"
    height="1em"
    :style="{
      ...(props.size ? { width: props.size, height: props.size } : {}),
      color: props.color,
    }"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M9.166 12.554C10.636 12.554 11.392 11.728 11.588 10.566H13.254C13.03 12.582 11.574 14.052 9.166 14.052C6.828 14.052 5.372 12.736 4.868 10.762H4V9.586H4.672C4.658 9.404 4.658 9.222 4.658 9.04C4.658 8.886 4.658 8.732 4.672 8.592H4V7.416H4.84C5.316 5.358 6.786 4 9.166 4C11.588 4 13.086 5.512 13.254 7.584H11.574C11.462 6.408 10.692 5.512 9.166 5.512C7.766 5.512 6.94 6.282 6.562 7.416H9.992L9.712 8.592H6.352C6.338 8.732 6.338 8.886 6.338 9.04C6.338 9.222 6.352 9.404 6.366 9.586H9.502L9.222 10.762H6.604C6.982 11.84 7.808 12.554 9.166 12.554Z"
    />
  </svg>
</template>
